const tables = [
  {
    name: "Account Name",
  },
  {
    name: "Code",
  },
  {
    name: "Type",
  },
  {
    name: "Category",
  },
  {
    name: "Status",
  },
  {
    name: "Balance",
  },
  {
    name: "Action",
  }
];

export default tables;
